<template>
	<div class="h-100">
		<sf-button line :onClick="searchSqlId">{{ getMessage_('SWCC000754') }}</sf-button>
		<sf-button line :onClick="addSql">{{ getMessage_('SWCC000755') }}</sf-button>
		<sf-card class="border-0 bg-transparent" style="height: 93%; padding-top: 10px">
			<!-- default-expand-all -->
			<el-tree class="tree" style="border-1" :data="menuTree" highlight-current @node-click="handleNodeClick"></el-tree>
			<!-- lazy
				:load="loadNode" -->
		</sf-card>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import { utils } from '@sfaas/util';
export default {
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...utils,
		...rootMethods,
		...serviceMethods,
		// loadNode(node, resolve) {
		// 	console.log(node);
		// 	// if (node.level === 0) {
		// 	// 	return resolve([{ name: 'region' }]);
		// 	// }
		// 	// if (node.level > 1) return resolve([]);
		// 	// setTimeout(() => {
		// 	// 	const data = [
		// 	// 		{
		// 	// 			name: 'leaf',
		// 	// 			leaf: true
		// 	// 		},
		// 	// 		{
		// 	// 			name: 'zone'
		// 	// 		}
		// 	// 	];
		// 	// 	resolve(data);
		// 	// }, 500);
		// },
		handleNodeClick(row) {
			this.$sf_toggleLoading(true);
			if (row.children.length == 0) {
				this.DEFAULT_ASSIGN({
					key: 'searchParams',
					value: { sqlId: row.sqlId, sqlParameters: [], sqlText: '' }
				});

				this.getSqlLog_(this.searchParams.sqlId)
					.then(this.getSqlContent_(this.searchParams.sqlId))
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} else {
				this.$sf_toggleLoading(false);
			}
		},
		searchSqlId() {
			this.$sf_toggleLoading(true);
			this.getFullSqlIds_({ urlSearchParams: 'currentPage=0&pageUnit=0' })
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		addSql() {
			const newSql = {
				sqlId: 'New Sql Id',
				sqlParameters: [],
				sqlText:
					' <sql id="NewSQLID"><!-- Writer        :  \n    Write Date    : 2010-02-08. \n    Description    : Getting the Station Code Information by Station Code. \n    History    : None. --><![CDATA[	]]></sql> '
			};

			this.sqlContent.push(newSql);
		}
	},
	watch: {
		// fullSqlIds() {
		// 	console.warn('Build tree....');
		// 	if (!this.isNull(this.fullSqlIds) && !this.isUndefined(this.fullSqlIds)) {
		// 		this.TREE_LIST({
		// 			value: this.fullSqlIds
		// 		});
		// 	}
		// }
	},
	created() {
		this.getFullSqlIds_({ urlSearchParams: 'currentPage=0&pageUnit=0' })
			.then(header => {
				this.$sf_toast({
					...this.$sf_setToastOption(header),
					message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
				});
			})
			.catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
	}
};
</script>

<style scss>
.el-tree {
	/* width: 20%; */
	display: flex;
	flex-direction: column;
	height: 100%;
}
</style>
